<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} extension
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.name"
                    :error-messages="errors"
                    label="Nombre"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
    },
  },

  data() {
    return {
      isLoading: false,
      trunksTypeList: [],
      clientList: [],
      payload: {
        name: "",
      },
    };
  },

  watch: {
    isEditMode(val) {
      if (val) this.payload = { ...this.dataToEdit };
      else this.payload = { name: "" };
    },
  },

  methods: {
    closeDialog(data = false) {
      this.$emit("dialog:close", data);
    },

    async submitForm() {
      this.isLoading = true;

      try {
        const { data } = await PbxHttpClient.post(
          "/server_externo/extension/rename",
          this.payload
        );

        if (data.status !== 200) throw Error;
        this.closeDialog(this.payload);

        this.$snotify.success(
          `Extension ${this.isEditMode ? "actualizada" : "creada"} con éxito.`,
          "¡Hecho!"
        );
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
      this.isLoading = false;
    },
  },
};
</script>
